import styled from "styled-components";
import { IconButton, spacing, color } from "@conserveit/blocks";
import { TYPOGRAPHY } from "../../../components/AppChrome/App.constants";

const $Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const $Header = styled.div`
  position: relative;
  padding: ${spacing.tight};
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

const $SelectionInfo = styled.div`
  padding: ${spacing.default};
  display: grid;
  grid-row-gap: 0;
  grid-column-gap: ${spacing.tight};
  grid-template-columns: 50px auto;
  background-color: ${color.pureWhite};
  font-size: 14px;
  line-height: 20px;
  color: ${color.theme.typography.ink};
  border-top: 1px solid ${color.theme.divider.solid};
`;

const $SelectionLabel = styled.span`
  font-size: 12px;
  font-weight: ${TYPOGRAPHY.WEIGHTS.BOLD};
`;

const $TabLabel = styled.span`
  height: ${spacing.ultraLoose};
  line-height: ${spacing.ultraLoose};
  display: inline-block;
  border: none;
  padding: 0 ${spacing.tight};
  outline: 0;
  font-size: 14px;
  font-weight: ${TYPOGRAPHY.WEIGHTS.BOLD};
  color: ${color.theme.typography.ink};
  text-decoration: none;
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: ${spacing.snug};
  margin: auto 0;
`;

export { $Container, $Header, $SelectionInfo, $SelectionLabel, $TabLabel };
